module.exports = __webpack_public_path__ + "static/media/11.f2552c6d.png";